export default "__VITE_ASSET__BNLkmUBZ__"